/**
 * Device token management for 30-day 2FA trust
 * Uses both cookie and localStorage for redundancy
 */

const DEVICE_TOKEN_KEY = '2fa_device_token';
const COOKIE_DAYS = 30;

export const deviceTokenManager = {
  /**
   * Store device token in both cookie and localStorage
   */
  setToken(token: string): void {
    // Store in localStorage
    localStorage.setItem(DEVICE_TOKEN_KEY, token);
    
    // Store in cookie with 30-day expiration
    const expires = new Date();
    expires.setDate(expires.getDate() + COOKIE_DAYS);
    
    // Set secure cookie (SameSite=Strict for security)
    document.cookie = `${DEVICE_TOKEN_KEY}=${token}; expires=${expires.toUTCString()}; path=/; SameSite=Strict`;
  },

  /**
   * Get device token from cookie or localStorage
   * Tries cookie first, then localStorage as fallback
   */
  getToken(): string | null {
    // Try to get from cookie first
    const cookies = document.cookie.split(';');
    console.log('[DeviceToken] All cookies:', document.cookie);
    
    for (const cookie of cookies) {
      const [name, value] = cookie.trim().split('=');
      if (name === DEVICE_TOKEN_KEY && value) {
        console.log('[DeviceToken] Found token in cookie:', value.substring(0, 10) + '...');
        // If found in cookie but not in localStorage, sync them
        if (!localStorage.getItem(DEVICE_TOKEN_KEY)) {
          localStorage.setItem(DEVICE_TOKEN_KEY, value);
        }
        return value;
      }
    }
    
    // Fallback to localStorage
    const localToken = localStorage.getItem(DEVICE_TOKEN_KEY);
    if (localToken) {
      console.log('[DeviceToken] Found token in localStorage:', localToken.substring(0, 10) + '...');
      // If found in localStorage but not in cookie, sync them
      this.setToken(localToken);
      return localToken;
    }
    
    console.log('[DeviceToken] No device token found');
    return null;
  },

  /**
   * Clear device token from both storage methods
   */
  clearToken(): void {
    // Clear from localStorage
    localStorage.removeItem(DEVICE_TOKEN_KEY);
    
    // Clear cookie by setting expiration to past
    document.cookie = `${DEVICE_TOKEN_KEY}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; SameSite=Strict`;
  },

  /**
   * Check if device is trusted
   */
  isTrusted(): boolean {
    return this.getToken() !== null;
  }
};